export default "__VITE_ASSET__BA2uA8pP__"